import { MarginChart } from './mocks/MarginChart'
import { LaneTable } from './mocks/LaneTable'

export function Examples() {
  return (
    <section id="examples" className="border-b border-border bg-muted/30">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <div className="max-w-2xl mb-10">
          <p className="eyebrow text-primary mb-3">Mysallar</p>
          <h2 className="text-[28px] sm:text-[36px] leading-tight font-semibold tracking-tight">
            Aý soňy — siziň maglumatlaryňyzdan.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="lg:col-span-3">
            <ChartCard
              title="Aýlyk marja"
              subtitle="Soňky 6 aýyň girdejisi we çykdajysy"
            >
              <MarginChart />
            </ChartCard>
          </div>
          <div className="lg:col-span-2">
            <ChartCard
              title="Bu aýyň öňdäki ugurlary"
              subtitle="Brut marja boýunça"
            >
              <LaneTable />
            </ChartCard>
          </div>
        </div>
      </div>
    </section>
  )
}

function ChartCard({
  title,
  subtitle,
  children,
}: {
  title: string
  subtitle: string
  children: React.ReactNode
}) {
  return (
    <div className="rounded-2xl border border-border bg-background overflow-hidden">
      <div className="px-6 pt-6 pb-4 border-b border-border">
        <h3 className="text-[18px] font-semibold tracking-tight text-foreground">{title}</h3>
        <p className="text-[13px] text-muted-foreground mt-1">{subtitle}</p>
      </div>
      <div className="p-6">{children}</div>
    </div>
  )
}
